import React from 'react';
import { motion } from 'framer-motion';
import GlobalReach from '../components/GlobalReach';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language];
  
  return (
    <div className="pt-20 bg-white">
      {/* Hero Section */}
      <section className="py-20 px-6 lg:px-12 bg-black text-white">
        <div className="max-w-5xl mx-auto text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-7xl font-bold mb-6"
          >
            Who is <span className="text-[#ff5200]">Pik</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl md:text-2xl text-gray-300"
          >
            {t.about.subtitle}
          </motion.p>
        </div>
      </section>

      {/* Who is Pik Section */}
      <section className="py-20 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold text-black mb-8"
          >
            {t.about.whoIsPikTitle}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg md:text-xl text-gray-700 leading-relaxed"
          >
            {t.about.whoIsPikText}
          </motion.p>
        </div>
      </section>

      {/* Global Reach Section */}
      <GlobalReach />

      {/* What We Believe Section */}
      <section className="py-20 px-6 lg:px-16 bg-[#ff5200]">
        <div className="max-w-[1600px] mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-white"
          >
            <h2 className="text-[clamp(1.5rem,3vw,3rem)] font-bold leading-[1.15] uppercase mb-4">
              {t.about.whatWeBelieve}
            </h2>
            {t.home.whatWeBelievelStatements.map((statement, index) => (
              <p key={index} className="text-[clamp(1.5rem,3vw,3rem)] font-bold leading-[1.15] uppercase mb-3">
                {statement}
              </p>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-20 px-6 lg:px-12 bg-[#ff5200] text-white">
        <div className="max-w-4xl mx-auto text-center">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold mb-8"
          >
            {t.about.mission}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-xl md:text-2xl leading-relaxed"
          >
            {t.about.missionText}
          </motion.p>
        </div>
      </section>
    </div>
  );
};

export default About;